import { useMutationState } from '@tanstack/react-query';
import type { TCSearcherTimelineItemDocument } from 'src/api/generated';
import type { QueryKey } from '@tanstack/react-query';
import { projectPendingMessages } from '../../../utils/whatsapp/pending-message-projection.util';
import {
  OUTBOUND_MESSAGE_MUTATION_KEY,
  getOutboundSupportScope,
  isOutboundMessageSubmission,
} from '../../../utils/whatsapp/outbound-message.util';

/**
 * Projects account-owned pending/failed submissions over refreshed timeline pages.
 * Canonical rows win by client identity, including socket delivery before HTTP.
 * @param queryKey - Timeline membership filters.
 * @param items - Authoritative cached timeline items.
 * @returns Visible timeline items plus this view's local outbound submissions.
 */
export const usePendingConversationMessages = (
  queryKey: QueryKey,
  items: TCSearcherTimelineItemDocument[]
): TCSearcherTimelineItemDocument[] => {
  const submissions = useMutationState({
    filters: { mutationKey: OUTBOUND_MESSAGE_MUTATION_KEY },
    select: (mutation) => {
      const variables = mutation.state.variables;
      return isOutboundMessageSubmission(variables) &&
        variables.supportScope === getOutboundSupportScope()
        ? { variables, status: mutation.state.status }
        : undefined;
    },
  });
  return projectPendingMessages(queryKey, items, submissions);
};
